type InputKeyState = {
    isPressed: boolean;
};

export class InputState {
    private readonly keyStates: Record<string, InputKeyState>;

    constructor(keyCodes: string[]) {
        this.keyStates = {};
        for (const keyCode of keyCodes) {
            this.keyStates[keyCode] = {
                isPressed: false
            };
        }
    }

    press(keyCode: string): void {
        const state = this.keyStates[keyCode];
        if (!state)
            return;

        state.isPressed = true;
    }

    release(keyCode: string): void {
        const state = this.keyStates[keyCode];
        if (!state)
            return;

        state.isPressed = false;
    }

    isPressed(keyCode: string): boolean {
        const state = this.keyStates[keyCode];
        return !!state && state.isPressed;
    }

    shouldRespond(keyCode: string): boolean {
        const state = this.keyStates[keyCode];
        return !!state && state.isPressed;
    }
}
